var render, staticRenderFns
import script from "./CrtListUser.vue?vue&type=script&lang=js&"
export * from "./CrtListUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fec13d2')) {
      api.createRecord('9fec13d2', component.options)
    } else {
      api.reload('9fec13d2', component.options)
    }
    
  }
}
component.options.__file = "src/views/User/List/CrtListUser.vue"
export default component.exports